var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "form-detail" } }, [
    _vm.loading
      ? _c("div", [_c("p", [_vm._v("Loading...")])])
      : _vm.form.form
      ? _c("div", [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "content" },
            [
              _c("div", { staticClass: "form-group" }, [
                _c("label", { staticClass: "form-title" }, [_vm._v("Başlık")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.form.title,
                      expression: "form.form.title",
                    },
                  ],
                  attrs: {
                    type: "text",
                    id: "form-title",
                    placeholder: "Bu form için bir isim girin",
                  },
                  domProps: { value: _vm.form.form.title },
                  on: {
                    input: [
                      function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.form.form, "title", $event.target.value)
                      },
                      _vm.debouncedUpdateFormTitle,
                    ],
                  },
                }),
              ]),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("div", { staticStyle: { display: "grid" } }, [
                  _c("label", { staticClass: "form-title" }, [
                    _vm._v("Form Durumu"),
                  ]),
                  _vm._v(" "),
                  _c("label", { staticClass: "subTitle" }, [
                    _vm._v(
                      "Formunuzu etkinleştirin, devre dışı bırakın veya koşullu olarak\n                        etkinleştirin"
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "form-settings-card",
                      staticStyle: { opacity: "0.5" },
                      on: { click: _vm.toggleSituationModal },
                    },
                    [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "a-modal",
                {
                  attrs: {
                    id: "situation-modal",
                    width: 700,
                    visible: _vm.situationModal,
                    footer: null,
                    header: null,
                  },
                  on: {
                    ok: _vm.toggleSituationModal,
                    cancel: _vm.toggleSituationModal,
                  },
                },
                [
                  _c("div", { staticClass: "modal-detail" }, [
                    _c("div", { staticClass: "modal-header-detail" }, [
                      _c("div", { staticClass: "icon-container" }, [
                        _c("i", { staticClass: "md-icon" }, [
                          _vm._v("assignment"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("h3", [_vm._v("FORM DURUMU")]),
                    ]),
                    _vm._v(" "),
                    _c("p", [_vm._v("Formunuzun durumunu seçin")]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("label", { attrs: { for: "form-status" } }, [
                          _vm._v("Form Durumu"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "a-space",
                          [
                            _c(
                              "a-select",
                              {
                                staticStyle: { width: "630px" },
                                attrs: { id: "form-status" },
                                model: {
                                  value: _vm.formStatus,
                                  callback: function ($$v) {
                                    _vm.formStatus = $$v
                                  },
                                  expression: "formStatus",
                                },
                              },
                              [
                                _c(
                                  "a-select-option",
                                  { attrs: { value: "one" } },
                                  [_vm._v("Etkin")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a-select-option",
                                  { attrs: { value: "two" } },
                                  [_vm._v("Devre Dışı")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a-select-option",
                                  { attrs: { value: "three" } },
                                  [
                                    _vm._v(
                                      "Belirtilen Bir Zamanda Devre Dışı Bırak\n                                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a-select-option",
                                  { attrs: { value: "four" } },
                                  [
                                    _vm._v(
                                      "Form Yanıtı limitine ulaşıldığında devre dışı bırak\n                                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a-select-option",
                                  { attrs: { value: "five" } },
                                  [
                                    _vm._v(
                                      "Belirtilen bir zamanda ya da yanıt limitine\n                                    ulaşıldığında devre dışı bırak\n                                "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "button-group" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn-cancel",
                          on: { click: _vm.toggleSituationModal },
                        },
                        [_vm._v("İPTAL")]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn-save",
                          on: { click: _vm.toggleSituationModal },
                        },
                        [_vm._v("KAYDET")]
                      ),
                    ]),
                  ]),
                ]
              ),
            ],
            1
          ),
        ])
      : _c("div", [_c("p", [_vm._v("Form bulunamadı.")])]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "icon-container" }, [
        _c("i", { staticClass: "md-icon" }, [_vm._v("settings")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "text-container" }, [
        _c("div", { staticClass: "title" }, [_vm._v("FORM AYARLARI")]),
        _vm._v(" "),
        _c("div", { staticClass: "description" }, [
          _vm._v("Form durumu ve özelliklerini değiştirin."),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon-section" }, [
      _c("i", { staticClass: "md-icon" }, [_vm._v("open_in_new")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-section" }, [
      _c("div", { staticClass: "title" }, [_vm._v("ETKİN")]),
      _vm._v(" "),
      _c("div", { staticClass: "description" }, [
        _vm._v(
          "Formunuz şu anda görünür durumda ve form yanıtı alabiliyor\n                            "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "arrow-section" }, [
      _c("i", { staticClass: "md-icon" }, [_vm._v("chevron_right")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }